import getIdentityOriginUrl from './getIdentityOriginUrl';

export default function redirectToIdentityApp() {
  window.location.href = `${getIdentityOriginUrl()}/logout`;
}
